<template>
  <div
    v-if="getItems"
    :class="['container__rigth', { 'container__rigth--show': showContainerRight }]"
  >
    <div class="container__rigth__request">
      <div
        v-if="showContainerCartMobile"
        class="container__rigth__request__header d-flex my-3"
        @click="hidePurchaseSummary()"
      >
        <AmIconMaterial
          :class="`container__rigth__request__header__icon text--${theme.color}`"
          name="arrow_back"
          size="md"
        />
        <AmTypography
          :class="`text--${theme.color}`"
          :text="$t('return')"
          typography-style="l5"
        />
      </div>
      <div
        v-else
        class="container__rigth__request__header"
      >
        <div class="container__rigth__request__header__items">
          <AmIconMaterial
            :class="`container__rigth__request__header__icon text--${theme.color}`"
            name="shopping_cart"
            size="md"
          />
          <AmTypography
            :class="`text--${theme.color}`"
            :text="
              $t('containerRigth.requests.myRequestItems', {
                items: padTotalItens(totalRequestItems),
                s: pluralIemsString,
              })
            "
            typography-style="l5"
          />
        </div>
        <div
          v-if="hiddenSelectCountries"
          class="container-right__countries"
        >
          <CountryListSelect />
        </div>
      </div>
      <ProductCart
        v-model="getBundles"
        :isRightPanelShown="showContainerCartMobile"
        :allowMultipleSales="allowMultipleSales"
      />
      <div class="container__rigth__request__prices">
        <div class="container__rigth__request__prices__subtotal">
          <div class="container__rigth__request__prices__subtotal__text">
            <AmTypography
              data-test="cart_subtotal"
              class="text--dark-3"
              :text="$t('containerRigth.requests.subtotal')"
              typography-style="l5"
            />
          </div>
          <div class="container__rigth__request__prices__subtotal__value">
            <AmSkeleton
              v-if="loadingCart"
              AmType="text"
              AmTextWidth="40"
              AmTextBorder
              AmTextHeight="sm"
              :AmTextGroupLimit="3"
            />
            <AmTypography
              v-else
              class="text--dark-3"
              typography-style="l5"
            >
              <template>
                <div>
                  {{ subTotal | currency({ codeCurrency: getCurrencyCode }) }}
                </div>
              </template>
            </AmTypography>
          </div>
        </div>
        <div
          v-for="tribute in tributes"
          :key="tribute.id"
          class="container-right__tributes"
          data-test="container-rigth:tributes"
        >
          <div class="container-right__wrapper">
            <div class="container-right__text">
              <AmTypography
                data-test="cart_subtotal"
                class="text--dark-3"
                :text="
                  $t('containerRigth.requests.tributes', {
                    name: tribute.name,
                    value: tribute.applied,
                  })
                "
                typography-style="l5"
              />
            </div>
            <div class="container-right__value">
              <AmSkeleton
                v-if="loadingCart"
                AmType="text"
                AmTextWidth="40"
                AmTextBorder
                AmTextHeight="sm"
                :AmTextGroupLimit="3"
              />
              <AmTypography
                v-else
                class="text--dark-3"
                typography-style="l5"
                data-test="container-right:value"
              >
                <template>
                  <div>
                    {{
                      tribute.value_converted
                        | currency({ codeCurrency: getCurrencyCode, signDisplay: 'always' })
                    }}
                  </div>
                </template>
              </AmTypography>
            </div>
          </div>
        </div>
        <div
          v-show="cartVerifyFreeFreight()"
          class="container__rigth__request__prices__delivery"
        >
          <div class="container__rigth__request__prices__delivery__text">
            <AmTypography
              data-test="cart_freight"
              class="text--dark-3"
              :text="$t('containerRigth.requests.delivery')"
              typography-style="l5"
            />
          </div>
          <div class="container__rigth__request__prices__delivery__value">
            <AmSkeleton
              v-if="loadingCart"
              AmType="text"
              AmTextWidth="40"
              AmTextBorder
              AmTextHeight="sm"
              :AmTextGroupLimit="3"
            />
            <AmTypography
              v-else
              typography-style="l5"
              :text-color="getTextColor()"
            >
              <template>
                <div
                  v-if="cartFreight()"
                  class="text--dark-3"
                >
                  {{ getFreight | currency({ codeCurrency: getCurrencyCode }) }}
                </div>
                <div v-else>
                  <span>{{ $t('containerRigth.requests.freeShipping') }}</span>
                </div>
              </template>
            </AmTypography>
          </div>
        </div>
        <div
          v-if="getCouponId"
          class="container__rigth__request__prices__discount"
        >
          <div class="container__rigth__request__prices__discount__text">
            <AmTypography
              data-test="cart_discount"
              class="text--dark-3"
              :text="$t('containerRigth.requests.couponDiscount', { coupon: getCouponCode })"
              typography-style="l5"
            />
          </div>
          <div class="container__rigth__request__prices__discount__value">
            <AmSkeleton
              v-if="loadingCart"
              AmType="text"
              AmTextWidth="40"
              AmTextBorder
              AmTextHeight="sm"
              :AmTextGroupLimit="3"
            />
            <AmTypography
              v-else
              class="text--dark-3"
              typography-style="l5"
            >
              <template>
                <div>-{{ getDiscount | currency({ codeCurrency: getCurrencyCode }) }}</div>
              </template>
            </AmTypography>
          </div>
        </div>
        <hr />
        <div class="container__rigth__request__prices__total">
          <div class="container__rigth__request__prices__total__text">
            <AmTypography
              class="text--dark-2"
              :text="$t('containerRigth.requests.total')"
              typography-style="l5"
              weight="bold"
            />
          </div>
          <div class="container__rigth__request__prices__total__value">
            <AmSkeleton
              v-if="loadingCart"
              AmType="text"
              AmTextWidth="40"
              AmTextBorder
              AmTextHeight="sm"
              :AmTextGroupLimit="3"
            />
            <AmTypography
              v-else
              data-test="cart_total"
              class="text--dark-2"
              typography-style="l5"
              weight="bold"
            >
              <template>
                <div>
                  {{ total | currency({ codeCurrency: getCurrencyCode }) }}
                </div>
              </template>
            </AmTypography>
          </div>
        </div>
      </div>
      <!-- TODO: esse trecho de código será ocultado pois a V1 do novo checkout ainda não irá contemplar a parte de produtos, apenas kits  -->
      <div class="container__rigth__request__recommended">
        <hr v-if="false" />
        <div
          v-if="false"
          class="container__rigth__request__recommended__you"
        >
          <AmTypography
            :class="`text--${theme.color}`"
            :text="$t('containerRigth.requests.recommended')"
            typography-style="l3"
          />
        </div>
        <div
          v-if="false"
          class="container__rigth__request__recommended__products"
        >
          <ProductRecommended
            v-for="item in 2"
            :key="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapState, mapGetters } from 'vuex'
import ProductCart from '@/views/Checkout/partials/ProductCart/ProductCart.vue'
import ProductRecommended from '@/views/Checkout/partials/ProductRecommended/ProductRecommended.vue'
import CountryListSelect from '../CountryListSelect/CountryListSelect.vue'

export default {
  name: 'ContainerRigth',
  components: {
    CountryListSelect,
    ProductCart,
    ProductRecommended,
  },
  mixins: [themeMixin, currencyFilterMixin],
  props: {
    showContainerRight: {
      type: Boolean,
    },
    allowMultipleSales: {
      default: true,
    },
  },
  data() {
    return {
      showTributes: false,
    }
  },
  computed: {
    ...mapState('Checkout', {
      loadingCart: (state) => state.cartLoading,
    }),
    ...mapGetters('Cart', [
      'getCurrencyCode',
      'getTributes',
      'getSelectedInstallment',
      'getIsInternational',
      'getTotal',
      'getSubtotal',
      'getFreight',
      'getFreightId',
      'getCouponId',
      'getCouponCode',
      'getDiscount',
      'isInternational',
      'getItems',
      'isInfoProduto',
      'getEnableInternational',
    ]),
    showContainerCartMobile() {
      return this.showContainerRight
    },
    getBundles() {
      return this.getItems.bundles
    },
    totalRequestItems() {
      return this.getBundles.length
    },
    pluralIemsString() {
      return this.totalRequestItems > 1 ? 'itens' : 'item'
    },
    hasTributes() {
      return this.getSelectedInstallment.tributes.length || this.getTributes.length
    },
    subTotal() {
      return this.getSelectedInstallment && this.getIsInternational
        ? this.getSelectedInstallment.subtotal
        : this.getSubtotal
    },
    total() {
      return this.getSelectedInstallment && this.getIsInternational
        ? this.getSelectedInstallment.total
        : this.getTotal
    },
    tributes() {
      return this.getSelectedInstallment && this.getIsInternational
        ? this.getSelectedInstallment.tributes
        : this.getTributes
    },
    hiddenSelectCountries() {
      const app_show = process.env.VUE_APP_SHOW_SELECT_COUNTRIES.replace(/"/g, '') === 'true'
      return app_show && this.isInfoProduto && this.getEnableInternational
    },
  },
  methods: {
    hidePurchaseSummary() {
      this.$emit('hidePurchaseSummary')
    },
    getTextColor() {
      return this.cartFreight() ? '' : 'success'
    },
    cartFreight() {
      return this.getFreight > 0
    },
    cartVerifyFreeFreight() {
      return this.getFreightId !== null
    },
    padTotalItens(totalItems) {
      return totalItems.toString().padStart(2, '0')
    },
  },
}
</script>

<style lang="scss" scoped>
.container__rigth {
  display: flex;
  flex-direction: column;
  min-width: 460px;
  flex: 1;
  min-height: 100%;
  background: $white;

  hr {
    margin: 0 16px 0 16px;
  }

  &__request {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      &__items {
        display: flex;
        flex-direction: row;
        height: 72px;
        align-items: center;
      }

      &__skeleton {
        width: 50%;
        margin: 28px;

        ::v-deep {
          .b-skeleton {
            background-color: $light-80 !important;
          }
          .b-skeleton-animate-wave::after {
            background: linear-gradient(90deg, transparent, $white, transparent);
          }
        }
      }

      &__icon {
        margin: 0 12px 0 0px;
      }
    }

    &__prices {
      width: 100%;
      margin: 16px 0 0 0;
      &__subtotal,
      &__delivery,
      &__total,
      &__discount,
      .container-right__tributes {
        display: flex;
        justify-content: space-between;
        margin: 10px 24px 10px 24px;
        &__text {
          ::v-deep {
            .b-skeleton {
              background-color: $light-80 !important;
            }
            .b-skeleton-animate-wave::after {
              background: linear-gradient(90deg, transparent, $white, transparent);
            }
          }
        }

        &__value {
          text-align: right;

          ::v-deep {
            .b-skeleton {
              background-color: $light-80 !important;
            }
            .b-skeleton-animate-wave::after {
              background: linear-gradient(90deg, transparent, $white, transparent);
            }
          }
        }
      }
    }

    .container-right__wrapper {
      display: inherit;
      flex-direction: row;
      justify-content: inherit;
    }

    .container-right__tributes {
      flex-direction: column;
    }

    &__recommended {
      display: flex;
      flex-direction: column;
      padding: 10px 0 100px 0;
      justify-content: flex-end;
      text-align: center;
      height: 100%;

      &__you {
        margin: 16px 0 16px 0;
      }

      &__products {
        display: flex;
        justify-content: space-evenly;
      }
    }
  }

  @include mobile {
    position: relative;
    left: 0;
    top: 0;
    min-width: 100%;
    display: none;
    padding-top: 0px;
    z-index: 4;

    &--show {
      display: flex;
    }
  }

  @include tablet {
    position: relative;
    left: 0;
    top: 0;
    min-width: 100%;
    display: none;
    padding-top: 0px;
    z-index: 4;

    &--show {
      display: flex;
    }
  }
}
</style>
